import ShareHoldingDirector from "./ShareholdingDirector";

export default ShareHoldingDirector;
